import * as Yup from 'yup';

const now = new Date();
const currentHour = now.getHours();
const currentMinutes = now.getMinutes();

export const AddNotificationSchema = Yup.object().shape({
    notification_title: Yup.string().trim().required("Please enter title"),
    notification_message: Yup.string().trim().required("Please enter message"),
    notification_scheduled_date: Yup.date().nullable().required("Please select a date"),
    notification_scheduled_time: Yup.string()
        .nullable()
        .when("notification_scheduled_date", (date, schema) => {
            if (!date) return schema.nullable();
            const selectedDate = new Date(date);
            const today = new Date();
            today.setHours(0, 0, 0, 0);
            return schema.test(
                "is-valid-time",
                "Time must be after the current time",
                (value) => {
                    if (!value) return false;
                    const [hour, minute] = value.split(":").map(Number);
                    if (selectedDate.getTime() === today.getTime()) {
                        return hour > currentHour || (hour === currentHour && minute >= currentMinutes);
                    }
                    return true;
                }
            );
        }),
});